import { StateCreator } from 'zustand';
import { produce } from 'immer';

// Utils
import { getInitialViewMode } from '@/utils/project';

// Types
import { UserConfigSlice, UserConfigState } from './types';

const initialUserConfigState: UserConfigState = {
  userConfig: {
    projectPage: {
      projectMemberViewMode: getInitialViewMode(),
      showRoleLabel: false,
    },
  },
};

export const createUserConfigSlice: StateCreator<
  UserConfigSlice,
  [],
  [],
  UserConfigSlice
> = (set) => ({
  ...initialUserConfigState,

  setProjectMemberViewMode: (projectMemberViewMode) =>
    set(
      produce((state) => {
        state.userConfig.projectPage.projectMemberViewMode =
          projectMemberViewMode;
      }),
    ),

  setShowRoleLabel: (showRoleLabel) =>
    set(
      produce((state) => {
        state.userConfig.projectPage.showRoleLabel = showRoleLabel;
      }),
    ),

  resetUserConfig: () => set(initialUserConfigState),
});
